<template>
  <card class="base-open-card" :class="{income: isIncome}">

    <template v-slot:default>
      <div class="identification">זיהיתי
        <span class="type">{{ questionName }}</span>
      </div>
      <div class="number">
        {{ formatAmount(isIncome ? question.incomeAmount : question.billingAmount) }}
        <span class="currency">₪</span>
      </div>
      <div class="details">
        <div class="date">{{ formatDate(question.transactionDate) }}</div>
        <div class="name">{{ question.businessName }}</div>
        <div class="account">{{ question.account }}</div>
        <div v-if="isInstallment">
          תשלום {{ question.installmentNumber }} מתוך {{ question.totalNumberOfInstallments }}
        </div>
      </div>
      <riseup-button v-for="button of buttons" :key="button.title" class="riseup-button"
                     :action="() => answerCashflowCategory(button.cashflowCategoryAnswer)"
                     :variant="button.variant"
                     :title="button.title"
                     :subtitle="button.subtitle"/>
    </template>

    <template v-slot:footer>
      <div class="not-cashflow" v-on:click="() => answerCashflowCategory(CASHFLOW_CATEGORIES.excluded)">
        זו לא {{ questionType }} תזרימית
      </div>
    </template>

  </card>
</template>

<script>
import BaseUI from 'base-ui';
import { mapActions, mapGetters, mapState } from 'vuex';
import Segment from '../../../../../../../../../Segment';
import moneyUtils from '../../../../../../../../../utils/money';
import dateUtils from '../../../../../../../../../utils/dates';

export default {
  name: 'BaseOpenCard',
  components: {
    Card: BaseUI.Card,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    question: Object,
    buttons: {
      type: Array,
      required: true,
    },
    questionName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('cashflowView', ['presentedBudgets']),
    ...mapGetters('cashflowCategoryActions', ['CASHFLOW_CATEGORIES']),
    isInstallment() {
      return !!this.question.totalNumberOfInstallments;
    },
    isIncome() {
      return !!this.question.incomeAmount;
    },
    questionType() {
      return this.isIncome ? 'הכנסה' : 'הוצאה';
    },
  },
  methods: {
    ...mapActions('cashflowCategoryActions', ['setCashflowCategory']),
    formatDate(date) {
      return dateUtils.shortDateFormat(date);
    },
    formatAmount(amount) {
      return moneyUtils.formatAmountWithFraction(amount, 0);
    },
    async answerCashflowCategory(answer) {
      const { transactionId, budgetDate } = this.question;
      Segment.trackUserInteraction('CategorizeTransactionClicked', {
        cashflowApp: true,
        question: {
          transactionDate: this.question.transactionDate,
          billingAmount: this.question.billingAmount,
          incomeAmount: this.question.incomeAmount,
          suggestedAnswer: this.question.suggestedAnswer,
          transactionId,
        },
        answer,
      });
      await this.setCashflowCategory({
        isLatestCashflow: this.presentedBudgets[0].budgetDate === budgetDate,
        transactionId,
        cashflowCategory: answer,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .base-open-card {
    text-align: right;
    margin-bottom: 16px;

    .identification {
      font-size: 16px;
      font-weight: bold;
      line-height: 10px;

      .type {
        color: $riseup_yellow;
      }
    }

    &.income {
      .identification {
        .type {
          color: $riseup_green
        }
      }
    }

    .number {
      font-size: 46px;
      font-weight: bold;
      margin: 24px 0 10px 0;

      .currency {
        font-size: 32px;
      }
    }

    .details {
      line-height: 18px;
      color: $riseup_black;

      .name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .riseup-button {
      width: 100%;
      margin-top: 22px;

      &.secondary {
        margin-top: 16px;
      }
    }

    .not-cashflow {
      text-align: center;
      font-weight: bold;
      color: $riseup_blue;
      text-decoration: underline;
      line-height: 10px;
      cursor: pointer;
    }
  }
</style>
